
export async function copyToClipboard (text) {
    try {
        await navigator.clipboard.writeText(text);
    } catch (error) {
        copyToClipboardFallback(text);
    }
}

function copyToClipboardFallback (text) {
    try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);   
    } catch (err) {
        console.log('cannot copy to clipboard ', text);
    }
}
